/**
 * Key / Value pair to translate API keys to better named, camelCased keys.
 * Any keys included in the request / response will be and not mapped here
 * will be removed.
 *
 * @var {Object} storeMap
 */
var storeMap = {
  brand_id: 'brandId',
  description: 'description',
  description_markdown: 'descriptionMarkdown',
  id: 'id',
  image: 'imageFilename',
  image_url: 'imageUrl',
  latitude: 'latitude',
  longitude: 'longitude',
  name: 'name',
  website: 'website',
  visible: 'visible'
};
export default storeMap;